import { useExpandedItems } from '@client/hooks/use-expand-elements.hooks';
import { CSV_IMPORT_EXPAND_PREFIX } from './import-list-navigation.helpers';
import { importHasUnusedColumns } from './import-unused-columns.helpers';
import { useElementImports } from './use-element-imports.hook';

/**
 * Whether the imports-tab "Show unused columns" header toggle should render:
 * any import file section is expanded (persisted) and has unmapped CSV columns.
 */
export const useImportUnusedColumnsToggleVisible = (
  projectId: number | undefined,
): boolean => {
  const imports = useElementImports(projectId ?? 0);
  const { is: isImportExpanded } = useExpandedItems({
    defaultPrefix: CSV_IMPORT_EXPAND_PREFIX,
  });

  if (!projectId || imports.status !== 'ready') return false;

  return Object.values(imports.data.importsById).some(
    (imp) => isImportExpanded(imp.id) && importHasUnusedColumns(imp),
  );
};
